<div class="form-floating position-relative">
  <input
    type="text"
    class="form-control cursor-pointer"
    readonly
    [value]="displayValue"
    (click)="toggle()"
  />
  <label>{{ label }}</label>
  <div *ngIf="open" class="month-picker-panel">
    <div class="d-flex justify-content-between align-items-center mb-3">
      <button
        type="button"
        class="btn btn-outline-secondary-2 rounded-circle px-3"
        (click)="displayYear = displayYear - 1"
      >
        &lsaquo;
      </button>
      <span class="fw-bold">{{ displayYear }}</span>
      <button
        type="button"
        class="btn btn-outline-secondary-2 rounded-circle px-3"
        (click)="displayYear = displayYear + 1"
      >
        &rsaquo;
      </button>
    </div>
    <div class="row row-cols-3 g-2">
      <div class="col" *ngFor="let name of monthNames; let i = index">
        <button
          type="button"
          class="btn w-100 rounded-pill"
          [ngClass]="isSelected(i) ? 'btn-primary' : 'btn-outline-secondary-2'"
          (click)="select(i)"
        >
          {{ name }}
        </button>
      </div>
    </div>
  </div>
</div>
